import { Stack } from '@mui/material';
import { useAuth } from 'context/Auth/AuthContext';
import { UserPermissions } from 'api/users/types';
import MenuItem from 'layouts/AppLayout/components/Sidebar/components/MenuItem';
import SubMenuItem from 'layouts/AppLayout/components/Sidebar/components/SubMenuItem';
import { fetchMainMenu } from 'layouts/AppLayout/components/Sidebar/constants';
import { ReactComponent as LogoIcon } from 'assets/icons/logo-blue.svg';
import { Drawer, DrawerHeader, MenuList } from 'layouts/AppLayout/components/Sidebar/styled';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { StyledChipNew } from 'components/styled';

const Sidebar = () => {
  // states
  const { user } = useAuth();

  // constants
  const open = false;
  const permissionsSchema = useMemo<Partial<UserPermissions> | null>(() => {
    return user?.permissionsSchema || user?.permissions || user?.appUser?.permissions || null;
  }, [user]);
  const newMenuItems = useMemo(() => fetchMainMenu(permissionsSchema), [permissionsSchema]);

  // The router's location, not `window.location`: the sidebar lives in the persistent layout, so
  // reading the global left it rendering for whichever page it first mounted on — e.g. Office Hours
  // still highlighted on Part Types after a client-side navigation (INV-5027).
  const { pathname } = useLocation();
  const currentPath = pathname.replace(/\/+$/, '') || '/';

  // functions
  const getIsMenuItemActive = (route: string, title: string) => {
    if (title === 'Logout') {
      return false;
    }

    const normalizedRoute = route.replace(/\/+$/, '') || '/';

    if (normalizedRoute === '/') {
      return currentPath === normalizedRoute;
    }

    return currentPath === normalizedRoute || currentPath.startsWith(`${normalizedRoute}/`);
  };

  return (
    <Drawer variant='permanent' open={open}>
      <Stack justifyContent={'space-between'} gap={'24px'} height={'100%'} pb={'16px'}>
      <Stack gap='24px'>
        <DrawerHeader>
          <LogoIcon />
        </DrawerHeader>

        <MenuList>
          {newMenuItems.map(({ icon: Icon, route, title }, index) => {
            return (
              <MenuItem
                key={index}
                MenuIcon={Icon}
                route={route}
                title={title}
                open={open}
                isActive={getIsMenuItemActive(route, title)}
              />
            );
          })}
        </MenuList>
      </Stack>
      <StyledChipNew status='info' smallSize typography={'labelXSmall'} rounded m={'4px'}>V0.1.0</StyledChipNew>
      </Stack>
    </Drawer>
  );
};

export default Sidebar;
